// extracted by mini-css-extract-plugin
export default {"detailsCard":"styles_detailsCard__G2Q7I","footer":"styles_footer__38rCK"};